import { AppThunk } from '../../../store/rootReducer';
import * as AnnotationTaskClient from '../clients/annotation-task.client';
import * as adminActions from '../actions/admin.actions';

export const loadAnnotationGridsList = (): AppThunk => async (dispatch) => {
  try {
    const annotationGridsList =
      await AnnotationTaskClient.getAllAnnotationGrid();
    if (annotationGridsList) {
      dispatch(
        adminActions.setAnnotationGridsList({
          annotationGridsList,
        }),
      );
    }
  } catch (error) {
    console.error('Error to load grid list:', error);
  }
};
